global.otuApp.webpack = {
    loadAsync(Options) { 
        var options = {
            jsFile:null,
            callback:null,
            assumeIncludedOnPdf:true
		};
        $.extend(options,Options );
        
        if (options.assumeIncludedOnPdf && global.isPdf) {
            console.log('Webpack - Skipping Loading Async ' + options.jsFile + ' assumed included on PDF');
            if (typeof options.callback=='function') options.callback();
            return true;

        } 

        console.log('Webpack - Loading Async ' + options.jsFile);

        import(`../myAsyncJs/${options.jsFile}`).then((view)=> {
            console.log('Webpack - Loaded Async ' + options.jsFile);
            if (typeof options.callback=='function') options.callback();
        });

        return true;

    }
}
    
